import React, { useEffect, useState } from "react";
import { Button, DataGrid } from "devextreme-react";
import { Column, HeaderFilter, Pager, Paging, Sorting } from "devextreme-react/data-grid";

import { useSurchargeSelectBoxState } from "@/hooks/useSurchargeSelectBoxState";
import SurchargeSelectBox from "../ReviewNewCharges/SurchargeSelectBox";
import { ReviewEmailTableColumns } from "@/shared/business/ReviewSendEmails";
import { usePopupDisplay } from "@/hooks/usePopupDisplay";
import EmailDetailForm from "./EmailDetailForm";
import { ReviewSendEmailsApi } from "@/shared/api/ReviewSendEmails.api";

const ReviewSendEmails: React.FC = () => {
  const { popupVisible, showPopUp, hidePopup } = usePopupDisplay();
  const {
    calculatedEvents,
    selectedSurchargeEvent,
    handleSurchargeEventChange,
    calculatedEventRuns,
    selectedCalculatedEventRun,
    handleSurchargeEventRunChange,
  } = useSurchargeSelectBoxState();

  const [emailList, setEmailList] = useState([] as any[]);
  const [formEditData, setFormEditData] = useState({} as any);

  useEffect(() => {
    selectedCalculatedEventRun && handleSurchargeEventRunChanged(selectedCalculatedEventRun.id);
  }, [selectedCalculatedEventRun]);

  const handleSurchargeEventRunChanged = async (selectedCalculatedEventRunId: string) => {
    var data = await ReviewSendEmailsApi.getEmails(selectedCalculatedEventRunId);
    if (!data) {
      return;
    }

    setEmailList(data);
  };

  const handleGenerateEmails = async () => {
    var data = await ReviewSendEmailsApi.generateEmails(selectedSurchargeEvent.id, selectedCalculatedEventRun.id);
    if (!data) {
      return;
    }

    setEmailList(data);
  };

  const handleRowClick = async (e: any) => {
    setFormEditData(e.data);
    showPopUp();
  };

  const handleEmailDetailFormClose = async (reloadData: boolean) => {
    hidePopup();
    if (reloadData) {
      await handleSurchargeEventRunChanged(selectedCalculatedEventRun.id);
    }
  };

  return (
    <>
      <h4>Review & Send Emails</h4>
      <div className="mt-4 mb-1 border-bottom border-1">
        <h6>Generate Emails for Approved Surcharge Event Calculations</h6>{" "}
      </div>

      <SurchargeSelectBox
        calculatedEvents={calculatedEvents}
        selectedSurchargeEvent={selectedSurchargeEvent}
        handleSurchargeEventChange={handleSurchargeEventChange}
        calculatedEventRuns={calculatedEventRuns}
        selectedCalculatedEventRun={selectedCalculatedEventRun}
        handleSurchargeEventRunChange={handleSurchargeEventRunChange}
      />

      {emailList && emailList.length === 0 && selectedSurchargeEvent && selectedCalculatedEventRun && (
        <div className="mt-3">
          <Button type="default" className="me-2" onClick={handleGenerateEmails}>
            GENERATE EMAILS
          </Button>
        </div>
      )}

      {emailList && emailList.length > 0 && (
        <DataGrid
          className="mt-2"
          dataSource={emailList}
          showBorders={true}
          keyExpr="id"
          focusedRowEnabled={false}
          repaintChangesOnly={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          hoverStateEnabled={true}
          wordWrapEnabled={true}
          columnAutoWidth={true}
          onRowClick={handleRowClick}
        >
          {/* <FilterRow visible={true} /> */}
          <HeaderFilter visible={true} />
          <Sorting mode="multiple" />
          <Paging enabled={true} defaultPageSize={10} />
          <Pager
            visible={true}
            allowedPageSizes={[10, 25, 50, 75]} // Options for page size
            showPageSizeSelector={true}
            showInfo={true} // Show "Page X of Y"
            showNavigationButtons={true}
          />

          {ReviewEmailTableColumns.map((column, index) => (
            <Column
              key={index}
              dataField={column.dataField}
              caption={column.caption}
              cellRender={(e) => <div className="cursor-point">{typeof e.value === 'boolean' ? e.value.toString() : e.value}</div>}
            ></Column>
          ))}
        </DataGrid>
      )}

      {popupVisible && (
        <EmailDetailForm
          visible={popupVisible}
          selectedSurchargeEvent={selectedSurchargeEvent}
          selectedCalculatedEventRun={selectedCalculatedEventRun}
          emailDetail={formEditData}
          closeForm={handleEmailDetailFormClose}
        ></EmailDetailForm>
      )}
    </>
  );
};

export default ReviewSendEmails;
